import React, { useEffect, useState, PropsWithChildren } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Sidebar } from "flowbite-react";
import Header from "../Header";
import { AiFillDashboard } from "react-icons/ai";
import { PiSteeringWheelFill } from "react-icons/pi";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { CiCircleList } from "react-icons/ci";
import { MdNotificationsActive } from "react-icons/md";
import { MdGroups } from "react-icons/md";
import { useSelector } from "react-redux";
import { BiBuildings } from "react-icons/bi";
import { FaUserPlus, FaUserSlash } from "react-icons/fa";

interface ContentLayoutProps extends PropsWithChildren {
  className?: string;
}

const navAdminItems = [
  {
    key: "dashboard",
    label: "Admin Dashboard",
    path: "/",
    icon: AiFillDashboard,
    children: [],
  },
  {
    key: "drivers",
    label: "Drivers / Users",
    path: "/drivers",
    icon: PiSteeringWheelFill,
    children: [],
  },
  {
    key: "companies",
    label: "Companies",
    path: "/companies",
    icon: BiBuildings,
    children: [],
  },
  {
    key: "referrals",
    label: "Referrals",
    path: "/referrals",
    icon: FaUserPlus,
    children: [],
  },
  {
    key: "abandonedUsers",
    label: "Abandoned Users",
    path: "/abandoned-users",
    icon: FaUserSlash,
    children: [],
  },
  {
    key: "contestPrizes",
    label: "Contest / Prizes",
    path: "/contestandprizes",
    icon: AiFillDashboard,
    children: [],
  },
  {
    key: "rewardpages",
    label: "Reward Pages",
    path: "/rewards",
    icon: AiFillDashboard,
    children: [],
  },
  {
    key: "prizeFullfillment",
    label: "Prize Fullfillment",
    path: "/prizeFullfillment",
    icon: CiCircleList,
    children: [],
  },
  {
    key: "pushNotifications",
    label: "Push Notifications",
    path: "/notifications",
    icon: MdNotificationsActive,
    children: [],
  },
  {
    key: "teamAccess",
    label: "Team Access",
    path: "/teamAccess",
    icon: MdGroups,
    children: [],
  },
  {
    key: "noonlight",
    label: "Noonlight Details",
    path: "/noonlight",
    icon: MdNotificationsActive,
    children: [],
  },
  // { key: "NFT", label: "NFT", path: "/nft", icon: FaNewspaper, children: [] },
];

const ContentLayout = ({ children, className = "" }: ContentLayoutProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const loginData = useSelector((state: any) => state?.auth?.loginData);

  const navItems =
    loginData?.user_type === "admin"
      ? navAdminItems
      : [
          {
            key: "prizeFullfillment",
            label: "Prize Fullfillment",
            path: "/prizeFullfillment",
            icon: CiCircleList,
            children: [],
          },
        ];
  const [activeNav, setActiveNav] = useState("dashboard");
  const [sideNavOpen, setSideNavOpen] = useState(true);

  useEffect(() => {
    const pathName: string = location.pathname;
    const side = localStorage.getItem("sidenav");
    setSideNavOpen(side === "true");
    navItems.forEach((item, index) => {
      if (item.children.length) {
        item.children.forEach((child: any, index) => {
          if (child.path === pathName) {
            setActiveNav(child.key);
          }
        });
      } else {
        if (item.path === pathName || pathName.includes(item.path)) {
          setActiveNav(item.key);
        }
      }
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const toggleSideNav = () => {
    localStorage.setItem("sidenav", (!sideNavOpen).toString());
    setSideNavOpen((prev) => !prev);
  };

  return (
    <div className={"h-screen"}>
      <Header toggleSideNav={toggleSideNav} />
      <div className={"flex h-[calc(100vh_-_65px)] bg-red-600"}>
        <Sidebar
          aria-label="Sidebar with multi-level dropdown example"
          className={`bg-primary transition-width duration-100 ${
            sideNavOpen ? "w-[256px]" : "w-auto"
          }`}
        >
          <Sidebar.Items>
            <Sidebar.ItemGroup className={"m-0 p-0"}>
              {navItems &&
                navItems.map((item, i) =>
                  item.children.length ? (
                    <Sidebar.Collapse
                      icon={item.icon}
                      label={item.label}
                      className={`border-b border-gray py-3 px-4 text-white flex items-center justify-start gap-2 cursor-pointer`}
                      renderChevronIcon={(theme, open) =>
                        open ? <IoIosArrowUp /> : <IoIosArrowDown />
                      }
                      open={item.children
                        .map((i: any) => i.key)
                        .includes(activeNav)}
                    >
                      {item.children.map((child: any, i) => (
                        <Sidebar.Item
                          className={`border-b border-gray py-3 px-4 text-white flex items-center justify-start ${
                            sideNavOpen ? "gap-2" : ""
                          } h-[50px] cursor-pointer ${
                            activeNav === child.key ? "bg-lightBlue" : ""
                          }`}
                          onClick={() => {
                            navigate(child.path);
                          }}
                          // icon={child.icon}
                        >
                          <div className={"w-full"}>
                            <p className={"text-left w-4/5 ml-auto"}>
                              {child.label}
                            </p>
                          </div>
                        </Sidebar.Item>
                      ))}
                    </Sidebar.Collapse>
                  ) : (
                    <Sidebar.Item
                      className={`border-y border-gray py-3 px-4 
                    ${
                      activeNav === item.key
                        ? "text-green border border-y-green"
                        : "text-white"
                    }
                    flex items-center justify-start h-[50px] 
                    ${sideNavOpen ? "gap-2" : ""}
                    cursor-pointer
                    ${activeNav === item.key ? "bg-lightBlue" : ""}
                    `}
                      onClick={() => {
                        navigate(item.path);
                      }}
                      icon={item.icon}
                    >
                      {sideNavOpen ? (
                        <p className={"text-left ml-2"}>{item.label}</p>
                      ) : null}
                    </Sidebar.Item>
                  )
                )}
            </Sidebar.ItemGroup>
          </Sidebar.Items>
        </Sidebar>
        <div
          className={`flex flex-1 p-4 flex-col bg-grayBack overflow-y-scroll ${className}`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default ContentLayout;
